export default __webpack_public_path__ + "static/media/XEMP-4.53026240.jpg";